import { useSelector } from "react-redux";

import { defineAbilityFor } from "context/Ability.context";
import {
  selectAuthCustomer,
  selectCurrentCustomerId,
  selectCurrentUser,
  selectCurrentUserId,
  selectCurrentUserIsVoltEmployee,
  selectCurrentUserPermissions,
} from "modules/auth/store/auth.slice";
import { getUserType } from "modules/user-management/utils/getUserType";

export function useDefineAbility() {
  const userId = useSelector(selectCurrentUserId);
  const user = useSelector(selectCurrentUser);
  const voltEmployee = useSelector(selectCurrentUserIsVoltEmployee);
  const permissionGroups = useSelector(selectCurrentUserPermissions);
  const customerId = useSelector(selectCurrentCustomerId);
  const customer = useSelector(selectAuthCustomer);

  const userType = !!user ? getUserType(user) : undefined;

  return defineAbilityFor({
    permissionGroups,
    voltEmployee,
    userId,
    customerId,
    hierarchyIds: customer?.globalFilterIds ?? [],
    userType,
  });
}
